import React, { useState, useEffect } from "react";

// import component 👇
import Drawer from "react-modern-drawer";

//import styles 👇
import "react-modern-drawer/dist/index.css";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

const Navigation = (args) => {
  const [isOpen1, setIsOpen1] = useState(false);

  const toggle = () => setIsOpen1(!isOpen);

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="nav-div">
      <Navbar {...args}>
        <div>
          <NavbarBrand href="/">
            <img src="/assets/logos/moshiul.svg" alt="" />
          </NavbarBrand>
        </div>
        <div>
          {viewportWidth < 768 ? (
            <>
              <NavbarToggler onClick={toggleDrawer} />
              <Drawer
                open={isOpen}
                onClose={toggleDrawer}
                direction="right"
                className="navbar_drawyer"
              >
                <Collapse isOpen={isOpen} navbar>
                  <Nav className="me-auto " navbar>
                    <NavItem>
                      <NavLink href="/about">About</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/education">Education</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/skills">Skills</NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink href="/projects">Projects</NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink href="/experience">Experience</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/research">Research</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="assets/resume/resume.pdf" target="_blank">
                        Resume
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/contact">Contact</NavLink>
                    </NavItem>
                  </Nav>
                </Collapse>
              </Drawer>
            </>
          ) : (
            <>
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <Nav className="me-auto " navbar>
                  <NavItem>
                    <NavLink href="/about">About</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/education">Education</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/skills">Skills</NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink href="/projects">Projects</NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink href="/experience">Experience</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/research">Research</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="assets/resume/resume.pdf" target="_blank">
                      Resume
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/contact">Contact</NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </>
          )}
        </div>
      </Navbar>
    </div>
  );
};

export default Navigation;
